import { COMPANY_NAME, COMPANY_DOMAIN, CONTACT_EMAIL, COMPANY_ADDRESS } from '../config';
import { useTranslation } from 'react-i18next';

const RefundPolicy = () => {
  const { t } = useTranslation();

  return (
    <div className="mx-auto max-w-3xl px-6 my-20">
      <div className="text-left">
        <h1>Refund policy</h1>

        <h2 className="mt-8">Flexible refunds</h2>
        <p>
          At {COMPANY_NAME}, we value our customers and strive to provide the best service possible. If you are not satisfied with your purchase, we offer a flexible refund policy to ensure a smooth experience. This policy applies to all payments processed through our payment gateway, Paddle.
        </p>

        <h2 className="mt-8">Refund eligibility</h2>
        <p>
          You may request a refund within <span className="font-bold">14 days</span> of your purchase date. Refunds are eligible only if:
        </p>
        <ul className="list-disc ml-5 mt-4">
          <li>You have not significantly used the service or accessed substantial data or features.</li>
          <li>The service did not function as described due to technical issues that we were unable to resolve.</li>
        </ul>
        <p>
          If you have actively used the platform beyond basic testing, refunds may be declined.
        </p>

        <h2 className="mt-8">Non-refundable purchases</h2>
        <p>
          The following purchases are <span className="font-bold">non-refundable</span>:
        </p>
        <ul className="list-disc ml-5 mt-4">
          <li>Subscriptions that have been fully used or accessed.</li>
          <li>Services provided and completed according to the subscription terms.</li>
          <li>Annual subscriptions after the initial 14-day refund window.</li>
        </ul>

        <h2 className="mt-8">Refund process</h2>
        <p>If your refund request is approved, the following will apply:</p>
        <ul className="list-disc ml-5 mt-4">
          <li>The refund will be processed through Paddle, our payment gateway.</li>
          <li>The refund will be credited to the original payment method used for the transaction.</li>
          <li>Refunds may take up to <span className="font-bold">10 business days</span> to be reflected in your account, depending on the payment method and bank processing times.</li>
        </ul>

        <h2 className="mt-8">Paddle support</h2>
        <p>
          If you have any questions or concerns regarding your refund request, please contact our support team at <span className="font-bold">{CONTACT_EMAIL}</span>. For further assistance, you may also contact Paddle’s customer support directly by visiting their <a href="https://www.paddle.com/support" className="text-blue-600">support page</a>.
        </p>

        <h2 className="mt-8">Transparency</h2>
        <p>
          At {COMPANY_NAME}, we strive to be transparent and fair in all our policies. We believe in offering our customers a risk-free experience with our products and services. Our refund policy is designed to ensure that you are satisfied with your purchase or receive a fair refund if necessary.
        </p>

        <h2 className="mt-8">Contact support</h2>
        <p>
          If you have any further questions or need assistance with your refund request, please do not hesitate to contact our support team at <span className="font-bold">{CONTACT_EMAIL}</span>. We are here to assist you!
        </p>
      </div>
    </div>
  );
};

export default RefundPolicy;
